var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isUserAllowedInLevel5or6)?_c('div',{staticClass:"flex-grow flex flex-col py-5 px-8"},[_vm._t("default")],2):_c('Forbidden')
}
var staticRenderFns = []

export { render, staticRenderFns }